(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-collection-controls"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cc-controls]').forEach(function(form){
  form.classList.add('cc-js');
  var panel=form.querySelector('.cc-filter-panel');
  if(panel){
    var summary=panel.querySelector('summary');
    var close=function(){panel.open=false;summary.focus();};
    panel.addEventListener('toggle',function(){
      document.documentElement.classList.toggle('cc-lock',panel.open);
      if(panel.open){var b=panel.querySelector('.cc-drawer-close');if(b)b.focus();}
    });
    panel.querySelectorAll('[data-cc-close]').forEach(function(el){el.addEventListener('click',function(e){e.preventDefault();close();});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&panel.open)close();});
  }
  form.querySelectorAll('[data-cc-more]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var on=btn.closest('.cc-group').classList.toggle('cc-group--all');
      btn.textContent=on?btn.getAttribute('data-less'):btn.getAttribute('data-more');
      btn.setAttribute('aria-expanded',on?'true':'false');
    });
  });
  form.querySelectorAll('[data-cc-search]').forEach(function(input){
    input.addEventListener('keydown',function(e){if(e.key==='Enter')e.preventDefault();});
    input.addEventListener('input',function(){
      var group=input.closest('.cc-group');
      var q=input.value.trim().toLowerCase();
      var any=false;
      group.classList.toggle('cc-group--searching',q!=='');
      group.querySelectorAll('.cc-opt').forEach(function(li){
        var match=!q||li.querySelector('.cc-opt-name').textContent.toLowerCase().indexOf(q)>-1;
        li.hidden=!match;
        if(match)any=true;
      });
      group.querySelector('.cc-no-match').hidden=any;
    });
  });
  var sort=form.querySelector('[data-cc-sort]');
  if(sort)sort.addEventListener('change',function(){if(form.requestSubmit){form.requestSubmit();}else{form.submit();}});
  form.addEventListener('submit',function(){form.querySelectorAll('input[type=number]').forEach(function(input){if(input.value==='')input.disabled=true;});});
});
  } catch(e) { console.error(e); }
})();

})();
